import React from "react";

import type { SentryClient } from "@app/services/sentry-facade";

export class ServiceProviderClientErrorBoundary extends React.Component<{
  sentry: SentryClient | undefined;
  children: React.ReactNode;
}> {
  public override componentDidCatch(error: Error) {
    this.props.sentry?.captureException(error, {
      tags: { type: "unhandled_exception" }
    });
  }

  public override render() {
    return this.props.children;
  }
}
